import React, {useEffect} from 'react';
import {loadTimelineData} from 'anima-timeline';
import "./InsightPage.css";
import {Link} from "react-router-dom";
import NavBar from "../NavBar";
import Footer from "../Footer";
import {InSights} from "../../data";



function App() {
  return <X06InsightsPageMobile {...x06InsightsPageMobileData} />;
}

export default App;

function X06InsightsPageMobile(props) {
  const {
    insights,
    rectangle76,
    text155,
    text1552,
    text1553,
    text1554,
    text1555,
    text1556,
    frame145Props,
    insightsCardProps,
    insightsCard2Props,
    insightsCard3Props,
    insightsCard4Props,
    insightsCard5Props,
    insightsCard6Props,
    insightsCard7Props,
    insightsCard8Props,
    //group2122Props,
  } = props;

  return (
    <div className="ipm-container-center-horizontal">
      <div className="ipm-x06-insights-page-mobile ipm-screen">
        {/* <Frame145 group86Props={frame145Props.group86Props} iconMenuProps={frame145Props.iconMenuProps} /> */}
        <NavBar/>
        <div className="ipm-insights ipm-valign-text-middle ipm-typographyheadlineh4-extrabold-24">{insights}</div>
        {/* <img className="ipm-rectangle-76" src={rectangle76} /> */}
        <img className="ipm-rectangle-76" src={InSights.InsightsHeader} alt="Webuildd Insights"/>
        <div className="ipm-text-3 ipm-typography-body-smalltext-14-regular">
          <p>{text155}</p>
          <p>{text1552}</p>
          <p>{text1553}</p>
          <p>{text1554}</p>
          <p>{text1555}</p>
          <p>{text1556}</p>
        </div>
        <div className="ipm-frame-1635">
          <InsightsCard
            x1600I27322861202={insightsCardProps.x1600I27322861202}
            text2={insightsCardProps.text2}
            button8Props={insightsCardProps.button8Props}
          />
          <InsightsCard2
            x1600I27322862202={insightsCard2Props.x1600I27322862202}
            propertyTaxI27322={insightsCard2Props.propertyTaxI27322}
            button8Props={insightsCard2Props.button8Props}
          />
          <InsightsCard3
            x1600I27322864202={insightsCard3Props.x1600I27322864202}
            propertyTaxI27322={insightsCard3Props.propertyTaxI27322}
            button8Props={insightsCard3Props.button8Props}
          />
          <InsightsCard4
            x1600I27322865202={insightsCard4Props.x1600I27322865202}
            propertyTaxI27322={insightsCard4Props.propertyTaxI27322}
            button8Props={insightsCard4Props.button8Props}
          />
          <InsightsCard5
            x1600I27322867202={insightsCard5Props.x1600I27322867202}
            propertyTaxI27322={insightsCard5Props.propertyTaxI27322}
            button8Props={insightsCard5Props.button8Props}
          />
          <InsightsCard6
            x1600I27322868202={insightsCard6Props.x1600I27322868202}
            propertyTaxI27322={insightsCard6Props.propertyTaxI27322}
            button8Props={insightsCard6Props.button8Props}
          />
          <InsightsCard7
            x1600I27322869202={insightsCard7Props.x1600I27322869202}
            propertyTaxI27322={insightsCard7Props.propertyTaxI27322}
            button8Props={insightsCard7Props.button8Props}
          />
           <InsightsCard78
            x1600I27322869202={insightsCard8Props.x1600I27322869202}
            propertyTaxI27322={insightsCard8Props.propertyTaxI27322}
            button8Props={insightsCard8Props.button8Props}
          />
        </div>
        {/* <Group2122
          group862Props={group2122Props.group862Props}
          group872Props={group2122Props.group872Props}
          group322Props={group2122Props.group322Props}
          frame5Props={group2122Props.frame5Props}
        /> */}
        <Footer/>
      </div>
    </div>
  );
}


function Frame145(props) {
  const { group86Props, iconMenuProps } = props;

  return (
    <div className="ipm-frame-145">
      {/* <Group86 group85={group86Props.group85} whiteProps={group86Props.whiteProps} />
      <IconMenu vector2={iconMenuProps.vector2} vector3={iconMenuProps.vector3} /> */}
    </div>
  );
}


function Group86(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="ipm-group-86">
      <White src={whiteProps.src} />
      <img className="ipm-group-85" src={group85} />
    </div>
  );
}


function White(props) {
  const { src } = props;

  return (
    <div className="ipm-white">
      <img className="ipm-vector" src={src} />
    </div>
  );
}


function IconMenu(props) {
  const { vector2, vector3 } = props;

  return (
    <div className="ipm-icon-menu">
      <img
        className="ipm-vector-2"
        src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg"
      />
      <img className="ipm-vector-1" src={vector2} />
      <img className="ipm-vector-1" src={vector3} />
    </div>
  );
}


function InsightsCard(props) {
  const { x1600I27322861202, text2, button8Props } = props;

  return (
    <div className="ipm-insights-card">
      <div className="ipm-group-69">
        <h1 className="ipm-x1600-i27323152202 ipm-valign-text-middle ipm-typographyheadlineh3-extrabold-30">{x1600I27322861202}</h1>
        <div className="ipm-text-4 ipm-valign-text-middle ipm-typography-body-smalltext-14-regular">{text2}</div>
      </div>
      <Link to="/insightdetails-bbmp">
        <Button8>{button8Props.children}</Button8>
      </Link>
    </div>
  );
}


function Button8(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(i273231522022185TimelineData);
  }, []);

  return (
    <div className="ipm-i27323152-2022185 component component-wrapper not-ready">
      <div className="ipm-master-button-xNmCxX">
        <div className="ipm-button-i2732315220-yif20o ipm-valign-text-middle">{children}</div>
      </div>
    </div>
  );
}

const i273231522022185TimelineData = [
  {
    initial_state_name: "Property-1=Primary",
    root_element: ".ipm-i27323152-2022185",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];


function InsightsCard2(props) {
  const { x1600I27322862202, propertyTaxI27322, button8Props } = props;

  return (
    <div className="ipm-insights-card-1">
      <div className="ipm-group-69-1">
        <div className="ipm-x1600-i27323153202 ipm-valign-text-middle ipm-typographyheadlineh3-extrabold-30">
          {x1600I27322862202}
        </div>
        <div className="ipm-property-tax-i27323 ipm-valign-text-middle ipm-typography-body-smalltext-14-regular">
          {propertyTaxI27322}
        </div>
      </div>
      <Link to="/insightdetails-bwssb">
        <Button8>{button8Props.children}</Button8>
      </Link>
    </div>
  );
}


function InsightsCard3(props) {
  const { x1600I27322864202, propertyTaxI27322, button8Props } = props;

  return (
    <div className="ipm-insights-card-2">
      <div className="ipm-group-69-2">
        <div className="ipm-x1600-i27323155202 ipm-valign-text-middle ipm-typographyheadlineh3-extrabold-30">
          {x1600I27322864202}
        </div>
        <div className="ipm-property-tax-i27323-1 ipm-valign-text-middle ipm-typography-body-smalltext-14-regular">
          {propertyTaxI27322}
        </div>
      </div>
      <Link to="/insightdetails-bescom">
        <Button8>{button8Props.children}</Button8>
      </Link>    </div>
  );
}


function InsightsCard4(props) {
  const { x1600I27322865202, propertyTaxI27322, button8Props } = props;

  return (
    <div className="ipm-insights-card-3">
      <div className="ipm-group-69-3">
        <div className="ipm-x1600-i27323156202 ipm-valign-text-middle ipm-typographyheadlineh3-extrabold-30">
          {x1600I27322865202}
        </div>
        <div className="ipm-property-tax-i27323-2 ipm-valign-text-middle ipm-typography-body-smalltext-14-regular">
          {propertyTaxI27322}
        </div>
      </div>
      <Link to="/insightdetails-procedure">
        <Button8>{button8Props.children}</Button8>
      </Link>    </div>
  );
}


function InsightsCard5(props) {
  const { x1600I27322867202, propertyTaxI27322, button8Props } = props;

  return (
    <div className="ipm-insights-card-4">
      <div className="ipm-group-69-4">
        <div className="ipm-x1600-i27323158202 ipm-valign-text-middle ipm-typographyheadlineh3-extrabold-30">
          {x1600I27322867202}
        </div>
        <p className="ipm-property-tax-i27323-3 ipm-valign-text-middle ipm-typography-body-smalltext-14-regular">
          {propertyTaxI27322}
        </p>
      </div>
      <Link to="/insightdetails-vaastu">
        <Button8>{button8Props.children}</Button8>
      </Link>    </div>
  );
}


function InsightsCard6(props) {
  const { x1600I27322868202, propertyTaxI27322, button8Props } = props;

  return (
    <div className="ipm-insights-card-5">
      <div className="ipm-group-69-5">
        <div className="ipm-x1600-i27323159202 ipm-valign-text-middle ipm-typographyheadlineh3-extrabold-30">
          {x1600I27322868202}
        </div>
        <div className="ipm-property-tax-i27323-4 ipm-valign-text-middle ipm-typography-body-smalltext-14-regular">
          {propertyTaxI27322}
        </div>
      </div>
      <Link to="/insightdetails-byelaws">
        <Button8>{button8Props.children}</Button8>
      </Link>    </div>
  );
}


function InsightsCard7(props) {
  const { x1600I27322869202, propertyTaxI27322, button8Props } = props;

  return (
    <div className="ipm-insights-card-6">
      <div className="ipm-group-69-6">
        <div className="ipm-x1600-i27323160202 ipm-valign-text-middle ipm-typographyheadlineh3-extrabold-30">
          {x1600I27322869202}
        </div>
        <div className="ipm-property-tax-i27323-5 ipm-valign-text-middle ipm-typography-body-smalltext-14-regular">
          {propertyTaxI27322}
        </div>
      </div>
      <Link to="/insightdetails-tips&ideas">
        <Button8>{button8Props.children}</Button8>
      </Link>    </div>
  );
}
function InsightsCard78(props) {
  const { x1600I27322869202, propertyTaxI27322, button8Props } = props;

  return (
    <div className="ipm-insights-card-7">
      <div className="ipm-group-69-6">
        <div className="ipm-x1600-i27323160202 ipm-valign-text-middle ipm-typographyheadlineh3-extrabold-30">
          {x1600I27322869202}
        </div>
        <div className="ipm-property-tax-i27323-5 ipm-valign-text-middle ipm-typography-body-smalltext-14-regular">
          {propertyTaxI27322}
        </div>
      </div>
      <Link to="/insightdetails-budget">
        <Button8>{button8Props.children}</Button8>
      </Link>    </div>
  );
}


// function Group2122(props) {
//   const { group862Props, group872Props, group322Props, frame5Props } = props;

//   return (
//     <div className="ipm-group-212">
//       <div className="ipm-flex-row">
//         <Group8622 group85={group862Props.group85} />
//         <Group872
//           overlapGroup={group872Props.overlapGroup}
//           vector2={group872Props.vector2}
//           facebookAppSymbolProps={group872Props.facebookAppSymbolProps}
//           twitterProps={group872Props.twitterProps}
//         />
//       </div>
//       <Group322 {...group322Props} />
//       <Frame5
//         quickLinks={frame5Props.quickLinks}
//         frame140Props={frame5Props.frame140Props}
//         frame1402Props={frame5Props.frame1402Props}
//         frame1403Props={frame5Props.frame1403Props}
//       />
//     </div>
//   );
// }


function Group8622(props) {
  const { group85 } = props;

  return (
    <div className="ipm-group-86-1">
      <div className="ipm-white-1">
        <img
          className="ipm-vector-3"
          src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-148@2x.svg"
        />
      </div>
      <img className="ipm-group-85-1" src={group85} />
    </div>
  );
}


function Group872(props) {
  const { overlapGroup, vector2, facebookAppSymbolProps, twitterProps } = props;

  return (
    <div className="ipm-group-87">
      <FacebookAppSymbol src={facebookAppSymbolProps.src} />
      <div className="ipm-instagram">
        <div className="ipm-overlap-group" style={{ backgroundImage: `url(${overlapGroup})` }}>
          <img
            className="ipm-vector-4"
            src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-18@2x.svg"
          />
          <img className="ipm-vector-5" src={vector2} />
        </div>
      </div>
      <Twitter src={twitterProps.src} />
    </div>
  );
}


function FacebookAppSymbol(props) {
  const { src } = props;

  return (
    <div className="ipm-facebook-app-symbol">
      <img className="ipm-f-1" src={src} />
    </div>
  );
}


function Twitter(props) {
  const { src } = props;

  return (
    <div className="ipm-twitter">
      <img className="ipm-vector-6" src={src} />
    </div>
  );
}


function Group322(props) {
  const { place, overlapGroup, phone, overlapGroup1, vector2, text165, text164, contactWebuildCom } = props;

  return (
    <div className="ipm-group-32">
      <div className="ipm-place ipm-valign-text-middle ipm-typographyheadlineh5-extrabold-20">{place}</div>
      <div className="ipm-flex-row-1">
        <div className="ipm-flex-col">
          <div className="ipm-map-pin-1">
            <div className="ipm-overlap-group-1" style={{ backgroundImage: `url(${overlapGroup})` }}>
              <img
                className="ipm-vector-7"
                src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-21@2x.svg"
              />
            </div>
          </div>
          <div className="ipm-phone" style={{ backgroundImage: `url(${phone})` }}></div>
          <div className="ipm-mail">
            <div className="ipm-overlap-group1" style={{ backgroundImage: `url(${overlapGroup1})` }}>
              <img className="ipm-vector-8" src={vector2} />
            </div>
          </div>
        </div>
        <div className="ipm-flex-col-1">
          <p className="ipm-text-2 ipm-typography-body-smalltext-14-regular">{text165}</p>
          <div className="ipm-flex-col-item ipm-valign-text-middle ipm-typography-body-smalltext-14-regular">{text164}</div>
          <div className="ipm-flex-col-item ipm-valign-text-middle ipm-typography-body-smalltext-14-regular">
            {contactWebuildCom}
          </div>
        </div>
      </div>
    </div>
  );
}


function Frame5(props) {
  const { quickLinks, frame140Props, frame1402Props, frame1403Props } = props;

  return (
    <div className="ipm-frame-5">
      <div className="ipm-quick-links ipm-valign-text-middle ipm-typographyheadlineh5-extrabold-20">{quickLinks}</div>
      <div className="ipm-frame-4">
        <Frame140 aboutUs={frame140Props.aboutUs} projects={frame140Props.projects} />
        <Frame140
          aboutUs={frame1402Props.aboutUs}
          projects={frame1402Props.projects}
          className={frame1402Props.className}
        />
        <Frame140
          aboutUs={frame1403Props.aboutUs}
          projects={frame1403Props.projects}
          className={frame1403Props.className}
        />
      </div>
    </div>
  );
}


function Frame140(props) {
  const { aboutUs, projects, className } = props;

  return (
    <div className={`ipm-frame-140 ${className || ""}`}>
      <div className="ipm-about-us ipm-valign-text-middle ipm-typographybody16-regular">{aboutUs}</div>
      <div className="ipm-projects ipm-valign-text-middle ipm-typographybody16-regular">{projects}</div>
    </div>
  );
}

const whiteData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg",
};

const group86Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/WebuilddLogo.svg",
    whiteProps: whiteData,
};

const iconMenuData = {
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
    vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
};

const frame145Data = {
    group86Props: group86Data,
    iconMenuProps: iconMenuData,
};

const button8Data = {
    children: "VIEW DETAILS",
};

const insightsCardData = {
    x1600I27322861202: "BBMP",
    text2: "Property Tax",
    button8Props: button8Data,
};

const button82Data = {
    children: "VIEW DETAILS",
};

const insightsCard2Data = {
    x1600I27322862202: "BWSSB",
    propertyTaxI27322: "Water Supply",
    button8Props: button82Data,
};

const button83Data = {
    children: "VIEW DETAILS",
};

const insightsCard3Data = {
    x1600I27322864202: "BESCOM",
    propertyTaxI27322: "Electricity Provider",
    button8Props: button83Data,
};

const button84Data = {
    children: "VIEW DETAILS",
};

const insightsCard4Data = {
    x1600I27322865202: "Procedure",
    propertyTaxI27322: "Steps taken for Construction",
    button8Props: button84Data,
};

const button85Data = {
    children: "VIEW DETAILS",
};

const insightsCard5Data = {
    x1600I27322867202: "Vaastu",
    propertyTaxI27322: "Boost positive energy in home",
    button8Props: button85Data,
};

const button86Data = {
    children: "VIEW DETAILS",
};

const insightsCard6Data = {
    x1600I27322868202: "Bye Laws",
    propertyTaxI27322: "Legal Documentation",
    button8Props: button86Data,
};

const button87Data = {
    children: "VIEW DETAILS",
};

const insightsCard7Data = {
    x1600I27322869202: "Tips & Ideas",
    propertyTaxI27322: "Construction Tips & Ideas",
    button8Props: button87Data,
};
const button88Data = {
  children: "VIEW DETAILS",
};

const insightsCard8Data = {
  x1600I27322869202: "Budget",
  propertyTaxI27322: "Construction Budget",
  button8Props: button88Data,
};

const group8622Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/Webuildd-Logo-White.svg",
};

const facebookAppSymbolData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1-1@2x.svg",
};

const twitterData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-157@2x.svg",
};

const group872Data = {
    overlapGroup: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-154@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-19@2x.svg",
    facebookAppSymbolProps: facebookAppSymbolData,
    twitterProps: twitterData,
};

const group322Data = {
    place: "Contact",
    overlapGroup: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-20@2x.svg",
    phone: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-14@2x.svg",
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-15@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-16@2x.svg",
    text165: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.",
    text164: "+91 8976535221, +91 8755645342",
    contactWebuildCom: "contact@webuild.com",
};

const frame140Data = {
    aboutUs: "About Us",
    projects: "Projects",
};

const frame1402Data = {
    aboutUs: "Gallery",
    projects: "Knowledge Transfer",
    className: "ipm-frame-14-1",
};

const frame1403Data = {
    aboutUs: "Blogs",
    projects: "FAQ’s",
    className: "ipm-frame-14",
};

const frame5Data = {
    quickLinks: "Quick Links",
    frame140Props: frame140Data,
    frame1402Props: frame1402Data,
    frame1403Props: frame1403Data,
};

// const group2122Data = {
//     group862Props: group8622Data,
//     group872Props: group872Data,
//     group322Props: group322Data,
//     frame5Props: frame5Data,
// };

const x06InsightsPageMobileData = {
    insights: "Insights",
    rectangle76: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-76@2x.png",
    text155: "WeBuildd has been delivering building solutions in Bengaluru and beyond for decades. But you are just getting started to turn your real estate dream into reality. So, let's go over some of the terminology and facts you'll encounter as you begin your journey.",
    text1552: "WeBuildd has been delivering building solutions in Bengaluru and beyond for decades. But you are just getting started to turn your real estate dream into reality. So, let's go over some of the terminology and facts you'll encounter as you begin your journey.",
    text1553: "Moreover, you must be aware of the actual costs of construction in Bengaluru to plan and fix a budget for your project. So, we have the information for you on that as well.",
    text1554: "Our steps of construction can be used as a map to start your project. We are sharing these insights to help you plan your journey more effectively.",
    text1555: "And don't forget to check out Vastu tips to design your home, as well as for house construction.",
    text1556: "So, let's get started...",
    frame145Props: frame145Data,
    insightsCardProps: insightsCardData,
    insightsCard2Props: insightsCard2Data,
    insightsCard3Props: insightsCard3Data,
    insightsCard4Props: insightsCard4Data,
    insightsCard5Props: insightsCard5Data,
    insightsCard6Props: insightsCard6Data,
    insightsCard7Props: insightsCard7Data,
    insightsCard8Props: insightsCard8Data,
    //group2122Props: group2122Data,
};

